/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type BlobStorageIntegrationFileType = "JSON" | "CSV" | "JSONL";
export const BlobStorageIntegrationFileType = {
  Json: "JSON",
  Csv: "CSV",
  Jsonl: "JSONL",
} as const;
